import { actionCreator, ActionReturnType, Loading, loadingFailed, loadingFinished, loadingIsLoading, loadingNotStarted } from "@itk/typescript-utils";
import { Model_ContactPersonVisibilityGet, Model_ProjectExtendedGet } from "src/backend/openapi/v1";
import { CreateProjectType } from "./add-edit-project-dialog-types";

export enum Action {
  CreateModifyProjectRequest = "@@ITK:SRC:PAGES:PROJECT-LIST:COMPONENTS:ADD-EDIT-PROJECT-DIALOG:ADD-EDIT-PROJECT-DIALOG-STORE.TS:ACTION:CREATEMODIFYPROJECTREQUEST",
  GetProjectRequest = "@@ITK:SRC:PAGES:PROJECT-LIST:COMPONENTS:ADD-EDIT-PROJECT-DIALOG:ADD-EDIT-PROJECT-DIALOG-STORE.TS:ACTION:GETPROJECTREQUEST",

  GetVisibilityContactPersonsRequest = "@@ITK:SRC:PAGES:PROJECT-LIST:COMPONENTS:ADD-EDIT-PROJECT-DIALOG:ADD-EDIT-PROJECT-DIALOG-STORE.TS:ACTION:GETVISIBILITYCONTACTPERSONSREQUEST",
  GetVisibilityContactPersonsSuccess = "@@ITK:SRC:PAGES:PROJECT-LIST:COMPONENTS:ADD-EDIT-PROJECT-DIALOG:ADD-EDIT-PROJECT-DIALOG-STORE.TS:ACTION:GETVISIBILITYCONTACTPERSONSSUCCESS",
  GetVisibilityContactPersonsFail = "@@ITK:SRC:PAGES:PROJECT-LIST:COMPONENTS:ADD-EDIT-PROJECT-DIALOG:ADD-EDIT-PROJECT-DIALOG-STORE.TS:ACTION:GETVISIBILITYCONTACTPERSONSFAIL",

  Clear = "@@ITK:SRC:PAGES:PROJECT-LIST:COMPONENTS:ADD-EDIT-PROJECT-DIALOG:ADD-EDIT-PROJECT-DIALOG-STORE.TS:ACTION:CLEAR"
}

type addEditProjectDialogState = {
  addEditProjectDialogState: Loading<Model_ProjectExtendedGet>;
  visibilityContactPersons: Loading<Model_ContactPersonVisibilityGet[]>;
};

const initialState: addEditProjectDialogState = {
  addEditProjectDialogState: loadingNotStarted,
  visibilityContactPersons: loadingNotStarted
};

export const addEditProjectDialogActions = {
  createModifyProjectRequest: (data: CreateProjectType, callBack: (isSuccess: boolean, projectId?: string) => void) => actionCreator(Action.CreateModifyProjectRequest, { data, callBack }),
  getProjectrequest: (projectId: string, customerId: string, callBack: (isSuccess: boolean, projectDetails?: Model_ProjectExtendedGet) => void) =>
    actionCreator(Action.GetProjectRequest, { projectId, customerId, callBack }),

  getVisibilityContactPersonsRequest: (customerId: string) => actionCreator(Action.GetVisibilityContactPersonsRequest, { customerId }),
  getVisibilityContactPersonsSuccess: (data: Model_ContactPersonVisibilityGet[]) => actionCreator(Action.GetVisibilityContactPersonsSuccess, { data }),
  getVisibilityContactPersonsFail: () => actionCreator(Action.GetVisibilityContactPersonsFail),

  clear: () => actionCreator(Action.Clear)
};

export const addEditProjectDialogReducer = (state = initialState, action: ActionReturnType<typeof addEditProjectDialogActions>): addEditProjectDialogState => {
  switch (action.type) {
    case Action.Clear:
      return initialState;

    case Action.GetVisibilityContactPersonsRequest: {
      return { ...state, visibilityContactPersons: loadingIsLoading };
    }
    case Action.GetVisibilityContactPersonsSuccess: {
      return { ...state, visibilityContactPersons: loadingFinished(action.payload.data) };
    }
    case Action.GetVisibilityContactPersonsRequest: {
      return { ...state, visibilityContactPersons: loadingFailed };
    }
    default:
      return state;
  }
};
